import type { ReactNode } from 'react';

/** CTA system: primary (Corporate Blue action), quiet (hairline on dark), light (hairline on light). */
export function Cta({ href, children, variant = 'primary', onClick }: { href: string; children: ReactNode; variant?: 'primary' | 'quiet' | 'light'; onClick?: () => void }) {
  return <a className={`cta cta--${variant}`} href={href} onClick={onClick}>{children}</a>;
}

/** Intake-page glyph and section rule (kept for the intake; the HOME does not use them). */
export function ArrowGlyph() {
  return (
    <svg className="cta__glyph" viewBox="0 0 20 12" width="20" height="12" aria-hidden="true" focusable="false">
      <path d="M0 6h17M12 1l5 5-5 5" fill="none" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}
export function SectionMark({ index, label, tone = 'dark' }: { index?: string; label: string; tone?: 'dark' | 'light' }) {
  return (
    <p className={`section-mark section-mark--${tone} micro`}>
      {index && <span className="section-mark__index">{index}</span>}
      <span className="section-mark__rule" aria-hidden="true" />
      <span>{label}</span>
    </p>
  );
}
